import { render } from "./Select.vue?vue&type=template&id=7c86ca36"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import "./Select.vue?vue&type=style&index=0&id=7c86ca36&lang=css"
script.render = render

export default script